module.exports = __webpack_public_path__ + "static/media/anc2ru.fa8a6677.pdf";